import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const TempoControl = ({ tempo, onTempoChange }) => {
  const { t } = useLanguage();

  const handleTempoUp = () => {
    const newTempo = Math.min(240, tempo + 5);
    onTempoChange(newTempo);
  };

  const handleTempoDown = () => {
    const newTempo = Math.max(40, tempo - 5);
    onTempoChange(newTempo);
  };

  const handleInputChange = (e) => {
    const newTempo = parseInt(e.target.value);
    if (!isNaN(newTempo) && newTempo >= 40 && newTempo <= 240) {
      onTempoChange(newTempo);
    }
  };

  return (
    <div className="text-center">
      <label className="block text-lg font-semibold mb-4 text-gray-700 dark:text-gray-300">
        🎵 {t('tempo')}
      </label>
      <div className="flex items-center justify-center space-x-4">
        <button
          onClick={handleTempoDown}
          className="w-12 h-12 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 text-white font-bold text-xl hover:scale-110 transition-transform duration-200"
        >
          −
        </button>
        <div className="bg-gray-100 dark:bg-gray-700 rounded-xl px-6 py-3">
          <input
            type="number"
            min="40"
            max="240"
            value={tempo}
            onChange={handleInputChange}
            className="w-20 text-center text-2xl font-bold bg-transparent border-none outline-none text-gray-900 dark:text-gray-100"
          />
        </div>
        <button
          onClick={handleTempoUp}
          className="w-12 h-12 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 text-white font-bold text-xl hover:scale-110 transition-transform duration-200"
        >
          +
        </button>
      </div>
    </div>
  );
};

export default TempoControl;